import { observer } from "mobx-react";
import { playerStore } from "../../../store/player.store"

const PlayerNote = observer(() => {
  return (
    <div>
      {playerStore.activeNote && (
        <div className="player-note">{playerStore.activeNote}</div>
      )}
    </div>
  );
});

export {
  PlayerNote
};
